import {MESSAGE_RECEIVE, MESSAGE_SEND} from '@glark-newco/game-library';
import {AssetsManifest} from 'pixi.js';

export const GAME_BACKGROUND = 'game_bg';
export const PLAY_BACKGROUND = 'play_bg';
export const POPUP_BG = 'popup';
export const OVERLAY = 'overlay';
export const BLUE_ROPE = 'blue-rope';
export const PINK_ROPE = 'pink-rope';
export const NOTEPAD = 'notepad';
export const POSTIT = 'postit_note';
export const CLIP_BLUE = 'clip-blue';
export const CLIP_GREEN = 'clip-green';
export const CLIP_RED = 'clip-red';
export const CLIP_YELLOW = 'clip-yellow';
export const GREEN_BUTTON = 'green-button';
export const CONFETTI = 'confetti';
export const PARTY_POPPER = 'party-popper';
export const STREAMERS = 'streamers';
export const CONGRATULATIONS = 'congratulations';
export const GAMEOVER = 'gameover';
export const ROPE_COIL = 'rope_coil';
export const TIME_PANEL = 'digital_clock';

export const WRITING_FONT = 'handwriting';
export const GENERAL_FONT = 'general';
export const LCD_FONT = 'lcd_font';

export const APPLAUSE = 'applause';
export const GAMEOVER_SOUND = 'gameover_sound';
export const BANKED_RING = 'banked_ring';
export const TRANSFER_RING = 'transfer_ring';
export const PLAYER_REMOVED = 'player_removed';

export const localManifest: AssetsManifest = {
    bundles: [
        {
            name: 'load-screen',
            assets: [
                {name: GAME_BACKGROUND, srcs: '../images/SupplyChain background.jpeg'},
                {name: PLAY_BACKGROUND, srcs: '../images/SupplyChain background.jpeg'},
                {name: POPUP_BG, srcs: '../images/SupplyChain popup background.png'},
                {name: OVERLAY, srcs: '../images/SupplyChain Overlay.png'},
                {name: BLUE_ROPE, srcs: '../images/rope-blue.png'},
                {name: PINK_ROPE, srcs: '../images/rope-pink.png'},
                {name: NOTEPAD, srcs: '../images/notepad.svg'},
                {name: GREEN_BUTTON, srcs: '../images/green-button.svg'},
                {name: POSTIT, srcs: '../images/postit_note.png'},
                {name: CLIP_BLUE, srcs: '../images/bulldog-clip-icon-blue.svg'},
                {name: CLIP_GREEN, srcs: '../images/bulldog-clip-icon-green.svg'},
                {name: CLIP_RED, srcs: '../images/bulldog-clip-icon-red.svg'},
                {name: CLIP_YELLOW, srcs: '../images/bulldog-clip-icon-yellow.svg'},
                {name: CONFETTI, srcs: '../images/confetti.svg'},
                {name: PARTY_POPPER, srcs: '../images/partypopper.svg'},
                {name: STREAMERS, srcs: '../images/streamers.svg'},
                {name: CONGRATULATIONS, srcs: '../images/congratulations.svg'},
                {name: GAMEOVER, srcs: '../images/gameover.svg'},
                {name: ROPE_COIL, srcs: '../images/rope-coil.png'},
                {name: TIME_PANEL, srcs: '../images/digitalClock.svg'},

                {name: WRITING_FONT, srcs: '../fonts/Mystyle-vJXL.ttf'},
                {name: GENERAL_FONT, srcs: '../fonts/Roboto-Variable.woff2'},
                {name: LCD_FONT, srcs: '../fonts/LCD14.woff2'},

                {name: APPLAUSE, srcs: '../sounds/applause.mp3'},
                {name: GAMEOVER_SOUND, srcs: '../sounds/game-over.mp3'},
                {name: MESSAGE_SEND, srcs: '../sounds/message-send.mp3'},
                {name: MESSAGE_RECEIVE, srcs: '../sounds/message-receive.mp3'},
                {name: BANKED_RING, srcs: '../sounds/banking-kaching.mp3'},
                {name: TRANSFER_RING, srcs: '../sounds/whoosh-motion.mp3'},
                {name: PLAYER_REMOVED, srcs: '../sounds/player_removed.mp3'},
            ],
        },
    ],
};


interface SpritesheetAsset {
    name: string
    alias: string[]
    src: string[]
}

export async function assetManifest(): Promise<AssetsManifest> {
    // Combines local manifest (above) and /public manifest made by the AssetPack
    const publicPixiManifest = await (await fetch('/assets/pixi/manifest.json')).json() as AssetsManifest;
    const publicTrimmedManifest = await (await fetch('/assets/trimmed/manifest.json')).json() as AssetsManifest;

    return {
        bundles: [
            {
                name: 'pixi',
                assets: [
                    ...(publicPixiManifest.bundles[0].assets as SpritesheetAsset[]).map((asset: SpritesheetAsset) => {
                        return {
                            name: asset.alias[0],
                            alias: [asset.alias[0]],
                            src: asset.src.map(s => `../assets/pixi/${s}`),
                        };
                    }),
                ],
            },
            {
                name: 'trimmed',
                assets: [
                    ...(publicTrimmedManifest.bundles[0].assets as SpritesheetAsset[]).map((asset: SpritesheetAsset) => {
                        return {
                            name: asset.alias[0],
                            alias: [asset.alias[0]],
                            src: asset.src.map(s => `../assets/trimmed/${s}`),
                        };
                    }),
                ],
            },
            ...localManifest.bundles,
        ],
    };
}
